module.exports = __webpack_public_path__ + "img/41.689c208e.png";